import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** A DELETE carries no body: the three identifiers only ever serve to build the route. */
class WithdrawInterviewConsent {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
	) {
		Object.freeze(this);
	}
}

export default WithdrawInterviewConsent;
